import React from 'react'

const CallIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" className={className} style={{ display: 'block' }} aria-hidden>
    <defs><style>{`.cls-1{fill:#fff;}`}</style></defs>
    <circle cx="32" cy="32" r="31.51" />
    <path className="cls-1" d="M38.12,25.23a5.57,5.57,0,0,0,5.13,3.31c3.73-.09,11.08-.47,10.66-6.33s-8.15-8.63-13-7.43S23.11,21.61,16.72,32.61,14.09,50,18,52.2a5.34,5.34,0,0,0,3.15.73,5,5,0,0,0,4.05-3.25c.75-2,2-5.5,1.91-7.13C27,40.21,24.35,38,24.35,38S31.28,26,38.12,25.23Z" />
  </svg>
)

export default CallIcon
